import { render, staticRenderFns } from "./HelpModal.vue?vue&type=template&id=4228e984&scoped=true"
import script from "./HelpModal.vue?vue&type=script&setup=true&lang=js"
export * from "./HelpModal.vue?vue&type=script&setup=true&lang=js"
import style0 from "./HelpModal.vue?vue&type=style&index=0&id=4228e984&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4228e984",
  null
  
)

export default component.exports